"use client";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAlert } from "@/hooks/useAlert";
import { NOT_AUTHORIZED_EVENT } from "@/lib/api/notAuthorized";

/**
 * Raises the one generic refusal message for actions the permission matrix
 * turns down, so a denied save or fetch says so instead of failing silently
 * or surfacing "Request Failed". The transport layer already logs the
 * response, so this only handles the telling.
 *
 * Refused *navigation* is a separate path that redirects to `/unauthorized`.
 * This is for refused actions, where the user stays put and gets told.
 *
 * Imports `notAuthorized` directly rather than through `@/lib/api`, whose
 * barrel re-exports the server-only surface.
 */
export default function NotAuthorizedAlert() {
  const { setAlert } = useAlert();
  const { t } = useTranslation("errors");

  useEffect(() => {
    const handler = () => {
      setAlert({
        status: "error",
        message: t("notAuthorized"),
        secondsToClose: 10,
      });
    };

    window.addEventListener(NOT_AUTHORIZED_EVENT, handler);
    return () => window.removeEventListener(NOT_AUTHORIZED_EVENT, handler);
  }, [setAlert, t]);

  return null;
}
